"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaType = void 0;
var MediaType;
(function (MediaType) {
    MediaType["Image"] = "image";
    MediaType["Video"] = "video";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
//# sourceMappingURL=media-type.js.map